import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.317 9.348c.436-.446 1.043-.481 1.576 0l3.908 3.747 3.908-3.747c.533-.481 1.14-.446 1.574 0 .436.445.408 1.197 0 1.615-.406.418-4.695 4.502-4.695 4.502a1.095 1.095 0 0 1-1.576 0s-4.287-4.084-4.695-4.502-.436-1.17 0-1.615" />
  </svg>
);
export const ArrowBeakIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
